import 'core-js/stable';
import 'regenerator-runtime/runtime';
import EyeCandy from './eyecandy';
import Logos from './logos';

class Scheybeeck {
  constructor() {
    this.stylesheetUri = '/wp-content/themes/scheybeeck';
    this.eyeCandy = new EyeCandy();
    this.logos = new Logos();
  }

  init() {
    const dotElements = [
      {
        selector: '.wpb_row.dots-orange',
        file: `${this.stylesheetUri}/dist/static/dots-orange.svg`,
      },
      {
        selector: '.wpb_row.dots-gray',
        file: `${this.stylesheetUri}/dist/static/dots-gray.svg`,
      },
      {
        selector: '.wpb_row.dots-black',
        file: `${this.stylesheetUri}/dist/static/dots-black.svg`,
      },
    ];

    dotElements.forEach((dotElement) => {
      this.appendSVG(dotElement.selector, dotElement.file);
    });

    this.logos.init();
    Scheybeeck.setContactLink();
  }

  appendSVG(selector, file) {
    // Get SVG contents      
    $.ajax({
      url: file,
      dataType: 'text',
    }).done((SVGContent) => {
      // Append SVG to each specified element
      $(selector).each((index, el) => {
        $(el).append(`<div class="dots">${SVGContent}</div>`);
        this.eyeCandy.setAnimateInClass(`${selector} .dots`);
      });
    });
  }

  static setContactLink() {
    const contactBtn = $('#social-in-menu a[href^=tel]');

    if ($(window).width() > 690) {
      contactBtn.attr('href', '/contact');
    }
  }
}

$(document).ready(() => {
  new Scheybeeck().init();
});
